<template>
  <main>
    <div class="row">
      <h4>{{ getTittle() }}</h4>
      <div class="d-block card p-2">
        <div class="col-md-12">
          <div class="row">
            <div class="col-2 pt-1 px-0">Filter by Oliver Sale</div>
              <div class="col-2 px-0 mx-0">
                <!-- :isDisabled="isUserOliverSale" -->
                <IndustrySearch
                  :option_list="userOliverSales"
                  :default_values="userOliverSale"
                  :key="key"
                  :multiple="false"            
                  @selected="selectOliverSale"
                />          
              </div>
            </div>
        </div>
      
        <div class="col-md-12 d-flex flex-row px-0 my-1">
          <!-- resultat-->
            {{ $t("lang.label.results") }}:
            <small v-if="!total" class="ml-1 mt-1 text-primary"
              >{{ $t("lang.search.calculating") }}...</small
            >
            <strong class="ml-1" v-else>{{ total }}</strong>
        </div>

      </div>

      <div class="col-12 px-0 card p-2 mt-2">

        <!-- Order Performances -->
        <template v-if="itemSelected == 19">
          <OrderPerformances
            :tabId="'19'"
            :condition="'LowCashableMargin'"
            :oliver_sale_id="oliver_sale_id"
            
          />
        </template>

        <!-- Order Performances -->
        <template v-if="itemSelected == 20">
          <OrderPerformances
            :tabId="'20'"
            :condition="'LowOperatingMargin'"
            :oliver_sale_id="oliver_sale_id"
            
          />
        </template>

        <!-- Order Performances -->
        <template v-if="itemSelected == 21">
          <OrderPerformances
            :tabId="'21'"
            :condition="'CriticalOperatingMargin'"
            :oliver_sale_id="oliver_sale_id"
            
          />
        </template>

        <!-- WAC -->
        <template v-if="itemSelected == 25">
            <TargetFinihsed
              :oliver_sale_id="oliver_sale_id"
              :key="key"
            />
        </template>

        <!-- High margin orders -->
       <template v-if="itemSelected == 32">
          <OrderPerformances
            :tabId="'32'"
            :condition="'HomCashableMargin'"
            :oliver_sale_id="oliver_sale_id"            
          />
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tabs from "@/components/Common/Tabs.vue";
import OrderPerformances from "@/components/Agencies/OrderPerformances.vue";
import Modal from "@/components/Common/Modal.vue";
import VideoToolToy from "@/components/Onboarding/VideoToolToy.vue";
import ContactSupply from "@/components/Agencies/ContactSupply.vue"
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";


import { adminService, targetsService, usersService } from "@/_services";
import TargetFinihsed from '../Targets/TargetFinihsed.vue';
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      total: null,
      key: 232332,
      oliver_sale_id: '0',
      previewUserOliverSale: "0",
      oliverSalesLoaded: false,
      savingOliverUser: false,
      userOliverSales: [{id: "0", label: "All"}],
      userOliverSale: ["0"],
      list: [],
      completeLoading: true,
      tabs: {
        //  15: {
        //   id: 15,
        //   name: 'Order Performances',
        //   total: null,
        // },
        // ids from task_history, check use unique values (EmailSyncList.vue and Performances.vue)
        19: {
          id: 19,
          name: "Low Cashable Margin",
          total: null,
        },
        20: {
          id: 20,
          name: "Low Operating Margin",
          total: null,
        },
        21: {
          id: 21,
          name: "Critical Operating Margin",
          total: null,
        },
        25: {
          id: 25,
          name: "WAC",
          total: null,
        },
        32: {
          id: 32,
          name: "High margin campaigns",
          total: null,
        }
      },
      itemSelected: 14,
    };
  },
  components: {
    LoadingSpinner,
    Tabs,
    VideoToolToy,
    Modal,
    ContactSupply,
    OrderPerformances,
    TargetFinihsed,
    IndustrySearch
  },
  created() {

    if (typeof this.$route.params.item !== "undefined") {
      this.itemSelected = this.$route.params.item
      this.changeTab(this.itemSelected)
    }


   if(this.isUserOliverSale) {
      this.oliver_sale_id = this.user.id
      this.init('created', this.oliver_sale_id)
   } else {
      this.init('created')
   }
  },

  mounted() {
    this.setHeader();
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    isUserOliverSale() {
      return (this.user.role_id == 1 && this.user.user_constraint_id == 2);
    },
  },

  methods: {
    ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    getTittle() {
      switch (parseInt(this.$route.params.item)) {
        case 19:
          return "Campaigns with low cashable margin";
        case 20:
          return "Campaigns with low operating margin";
        case 21:
          return "COM";
        case 25:
          return "WAC";
        case 32:
          return "High margin campaigns";
        default:
          return "";
      }
    },
    setHeader(){
      switch (parseInt(this.$route.params.item)) {
        case 19:
          this.setCurrentRoute({ page: "low-cashable-margin", label: "Low Cashable Margin" });
          break;
        case 20:
          this.setCurrentRoute({ page: "low-operating-margin", label: "Low Operating Margin" });
          break;
        case 21:
          this.setCurrentRoute({ page: "com", label: "COM" });
          break;
        case 25:
          this.setCurrentRoute({ page: "wac", label: "WAC" });
          break;
        case 32:
          this.setCurrentRoute({ page: "high-margin-orders", label: "High Margin Campaigns" });
          break;
      }
    },

    init(origin, userOliverSaleId) {
      if (origin == 'created') {
        this.getUserOliverSales()
      }
      
     if(this.itemSelected == 19 || this.itemSelected == 20 || this.itemSelected == 21 || this.itemSelected == 32) {
      let condition;
      switch (this.itemSelected) {
        case 19:
          condition = 'LowCashableMargin'
          this.getTargetToProfitability('count', this.itemSelected, condition, userOliverSaleId);
          break;
        case 20:
          condition = 'LowOperatingMargin'
          this.getTargetToProfitability('count', this.itemSelected, condition, userOliverSaleId);
          break;
        case 21:
          condition = 'CriticalOperatingMargin'
          this.getTargetToProfitability('count', this.itemSelected, condition, userOliverSaleId);
          break;     
        case 32:
          condition = 'HomCashableMargin'
          this.getTargetToProfitability('count', this.itemSelected, condition, userOliverSaleId);
          break;  
          
        default:
          break;
      }
      
      }
      if(this.itemSelected == 25) {
          this.getCountWac('count', 25, userOliverSaleId);
      }
    },

    selectOliverSale(value){
      this.oliver_sale_id = value.id
      const userOliverSaleId = value.id

      if(userOliverSaleId != this.previewUserOliverSale){
        this.init(null, userOliverSaleId);
        this.previewUserOliverSale = userOliverSaleId
      }
    },

    getUserOliverSales(){
      usersService.getUserOliverSales(true, 0, true)
      .then( res => {
        if(res.result.length > 0) {
          const userOliverSalesWithlabel = res.result.map( el => ({ ...el, label: el.lastname + ", " + el.name}))
          this.userOliverSales.push(...userOliverSalesWithlabel)
          this.oliverSalesLoaded = true
          this.userOliverSales.map((it)=>{
            if(it.id == this.$store.state.authentication.user.id){
                this.userOliverSaleId = it.id
                this.userOliverSale = [it.id.toString()]

            }
          })
          //this.getTargetContactSupply('count', 14, this.userOliverSaleId);
          this.key++
        }
      })
      .catch( err => console.error(err))
    },

    getTargetToProfitability(count = 0, tab = null, condition = 0, oliver_sale_id = 0)  {
      this.completeLoading = false;
      const itemSelected = tab ? tab : this.itemSelected;

      targetsService.getTargetListToProfitability(itemSelected, count, condition, oliver_sale_id)
        .then((result) => {
          //this.targetMissinDataItems = result;
          if (count) {
            this.tabs[tab].total = result.result.count ? result.result.count : "0";
            this.total = result.result.count ? result.result.count : "0";
          }
          this.completeLoading = true;
        })
    },

    getCountWac(count,tab = null, oliver_sale_id = 0){
      targetsService.getFinishedTarget(count, tab, oliver_sale_id).then((res)=>{
        if (count) {
          this.tabs[tab].total = res.count ? res.count : "0";
          this.total = res.count ? res.count : "0";
        }          
      })
    },
    getTargetContactSupply(count = 0, tab = null,  oliver_sale_id = 0)  {
      this.completeLoading = false;
      const itemSelected = tab ? tab : this.itemSelected;

      targetsService.getTargetContactSupply(itemSelected, count,  oliver_sale_id)
        .then((result) => {
          //this.targetMissinDataItems = result;
          if (count) {
            this.tabs[tab].total = result.count ? result.count : "0";
          }

          this.completeLoading = true;
        });
    },
    closeModal(modal) {
      this.$modal.hide(modal);
    },
    openModal(modal) {
      this.$modal.show(modal);
    },

    getEmailSyncList(count = null, tab = null) {
      this.completeLoading = false;
      const itemSelected = tab ? tab : this.itemSelected;
      adminService.getEmailSyncList(itemSelected, count).then(
        (result) => {
          if (count) {
            this.tabs[tab].total = result.count ? result.count : "0";
          }
          this.list = result;
          this.completeLoading = true;
        },
        (error) => {
          this.$store.dispatch("alert/error", error, { root: true });
        }
      );
    },

    changeTab(index) {
      this.itemSelected = this.tabs[index].id;
      this.key++
    },
  },
};
</script>
